import React from 'react';

import { connect } from 'react-redux';

import { Modal, notification, Tabs } from 'antd';

import EnterpriseSelector from './list-selector';
import EnterpriseEditor from './editor';

import { setManagedUserEnterprise } from '../user/actions';

import { 
	_postAddEnterprise, 
	_postAssignEnterpriseToUser, 
	_postEditEnterprise 
} from '../../services';

import './index.css';

const { TabPane } = Tabs;

const defaultState = {
	err: false,
	loading: false,
	selectedEnterprise : {},
	reset: false,
	valid: false
};

class EnterpriseSelectionModal extends React.Component{

	state = defaultState;

	render(){

		const { visible = false, enterprise } = this.props;
		const { loading, selectedEnterprise } = this.state;

		return(
			<Modal 	
				destroyOnClose={true}
				onOk={ this.handleAssignUser }
				confirmLoading={loading}
				okText={`${loading?'loading':'Assign'}`}
				maskClosable={false} 
				onCancel={this.props.onCancel} 
				visible={visible}>

					{
						visible && !enterprise && (

							<Tabs defaultActiveKey="select" onChange={ this.handleClearSelected }>

								<TabPane tab="Select Enterprise" key="select">
									<EnterpriseSelector 
										clearSelected={ this.handleClearSelected }
										selectedEnterprise={this.state.selectedEnterprise} 
										onSelect={ this.handleOnSelectEnterprise } />
								</TabPane>

								<TabPane tab="Add Enterprise" key="add">
									<EnterpriseEditor 
										enterprise={ {} }
										invalidateField={ this.handleInvalidateEnterprise }
										onChange={ this.handleOnChangeEnterprise }
										onError={ this.handleOnError }
										buttons={false} />
								</TabPane>

							</Tabs>
							
						)
					}

					{
						enterprise && visible && (
							<div style={{ marginTop: 10 }}>
								<EnterpriseEditor 
									enterprise={ selectedEnterprise }
									invalidateField={ this.handleInvalidateEnterprise }
									onChange={ this.handleOnChangeEnterprise }
									onError={ this.handleOnError }
									buttons={false} />
							</div>
							
						)
					}

			</Modal>
		);
	}

	constructor( props ){
		super(props);

		if( props.enterprise ){
			this.state = { 
				...defaultState,
				selectedEnterprise: props.enterprise 
			};
		}
	}

	handleAssignUser = () => {

		const { valid, err } = this.state;

		if( !valid ){

			if( err ){
				return Object.keys(err).map(
					errKeys => {
						err[ errKeys ].errors.map(
							errMsg => notification.error({message: errMsg.message})
						)

						return errKeys;
					}
				)
			}

			return notification.error({ message: "Plese select an enterprise!"})
		}

		// send to server
		const { selectedEnterprise } = this.state;
		
		// if new enterprise, make 
		if(!selectedEnterprise._id){
			
			return _postAddEnterprise({
				enterprise: selectedEnterprise,
				userId: this.props.userId
			})
				.then( res => {
					if( res.data.success ){
						this.props.onCancel();
						this.props.setManagedUserEnterprise({
							enterprise: res.data.enterprise,
							userMap: res.data.userMap
						});
					}
				})

		}

		if( this.props.enterprise ){
			return _postEditEnterprise({
				enterprise: selectedEnterprise
			})
				.then( res => {
					if( res.data.success ){
						this.props.onCancel();
						this.props.setManagedUserEnterprise({
							enterprise: res.data.enterprise,
							userMap: res.data.userMap
						});
					}
				})
		}

		return _postAssignEnterpriseToUser({
			enterpriseId: selectedEnterprise._id,
			userId: this.props.userId
		})
			.then( res => {
				if( res.data.success ){
					this.props.onCancel();
					this.props.setManagedUserEnterprise({
						enterprise: res.data.enterprise,
						userMap: res.data.userMap
					});
				}
			})

	}

	handleClearSelected = () => {
		this.setState({
			selectedEnterprise: {},
			valid: false
		})
	}

	handleInvalidateEnterprise = ( obj = { loading : false } ) => {

		obj = obj || {};
		obj.loading = obj.loading || false;

		this.setState({
			loading: obj.loading,
			valid: false
		});
	}

	

	handleOnChangeEnterprise = ( enterpriseData ) => {

		console.log( enterpriseData );

		this.setState({
			valid: true,
			loading: false,
			err: false,
			selectedEnterprise: {
				...this.state.selectedEnterprise,
				...enterpriseData
			}
		})
	}

	handleOnError = ( err ) => {
		this.setState({
			valid: false,
			loading: false,
			err
		})
	}

	handleOnSelectEnterprise = ( enterprise ) => {
		this.setState({ 
			selectedEnterprise: enterprise,
			valid: true
		})
	}
}

export default connect(

	state => ({}),
	dispatchEvent => ({
		setManagedUserEnterprise: ( obj ) => dispatchEvent( setManagedUserEnterprise( obj ) )
	})

)( EnterpriseSelectionModal );


// WEBPACK FOOTER //
// ./src/components/enterprise/selection-modal.js